import { StateCreator, createStore } from 'zustand'
import { devtools } from 'zustand/middleware'
import { immer } from 'zustand/middleware/immer'

import { IS_PROD_LIKE_ENVIRONMENT } from '@/constants/env'

// region store types

export interface DashboardStoreState {
  createPursuitDialogIsOpen: boolean
  setCreatePursuitDialogIsOpen: (isOpen: boolean) => void

  uploadLibraryFileDialogIsOpen: boolean
  setUploadLibraryFileDialogIsOpen: (isOpen: boolean) => void
}

const INIT_STORE: StateCreator<DashboardStoreState> = (set, get) => ({
  createPursuitDialogIsOpen: false,
  setCreatePursuitDialogIsOpen: (isOpen) =>
    set({ createPursuitDialogIsOpen: isOpen }),

  uploadLibraryFileDialogIsOpen: false,
  setUploadLibraryFileDialogIsOpen: (isOpen) =>
    set({ uploadLibraryFileDialogIsOpen: isOpen }),
})

// endregion store types

// region store

export type DashboardStore = ReturnType<typeof createDashboardStore>

export const createDashboardStore = () => {
  if (IS_PROD_LIKE_ENVIRONMENT) {
    return createStore<DashboardStoreState, [['zustand/immer', never]]>(
      immer<DashboardStoreState>((set, get, store) => ({
        ...INIT_STORE(set, get, store),
      })),
    )
  }

  return createStore<
    DashboardStoreState,
    [['zustand/devtools', never], ['zustand/immer', never]]
  >(
    devtools(
      immer<DashboardStoreState>((set, get, store) => ({
        ...INIT_STORE(set, get, store),
      })),
    ),
  )
}

// endregion store
